export const login = '/auth/local'



// WEBPACK FOOTER //
// ./src/api/config.js